module.exports = __webpack_public_path__ + "assets/google-sheet-active.c2c4f607.svg";